/* RAVENRYSE - Descripciones de producto desplegables.
   Convierte cada apartado de la descripción que empieza con un título H3
   (Características, Guía de tallas, Uso, Cuidado, Envío...) en un desplegable
   cerrado. El texto de introducción de arriba sigue visible.
   Para deshacer: borrar este archivo y su línea en snippets/stylesheets.liquid. */
(function () {
  var SELECTOR = 'rte-formatter[class*="product_description"]';

  function build(root) {
    if (root.querySelector(':scope > details.rr-desc')) return;
    var heads = Array.prototype.filter.call(root.children, function (el) {
      return el.tagName === 'H3';
    });
    if (!heads.length) return;

    heads.forEach(function (h) {
      var details = document.createElement('details');
      details.className = 'rr-desc';

      var summary = document.createElement('summary');
      summary.className = 'rr-desc__head';
      var title = document.createElement('span');
      title.textContent = h.textContent.trim();
      var icon = document.createElement('span');
      icon.className = 'rr-desc__icon';
      icon.setAttribute('aria-hidden', 'true');
      summary.appendChild(title);
      summary.appendChild(icon);

      var body = document.createElement('div');
      body.className = 'rr-desc__body';
      var next = h.nextElementSibling;
      while (next && !/^H[1-3]$/.test(next.tagName)) {
        var after = next.nextElementSibling;
        body.appendChild(next);
        next = after;
      }

      details.appendChild(summary);
      details.appendChild(body);
      h.replaceWith(details);
    });
  }

  function run() {
    document.querySelectorAll(SELECTOR).forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* El tema vuelve a pintar la ficha al cambiar de variante: se reaplica. */
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      run();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
